/* terminal/actions */
import { action } from "typesafe-actions";
import { OfflinePaymentTypeGroup, OfflinePaymentTypeGroupActionTypes } from "./types";

export const fetchRequest = (
  id?: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(OfflinePaymentTypeGroupActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (closeloop: OfflinePaymentTypeGroup) =>
  action(OfflinePaymentTypeGroupActionTypes.FETCH_SUCCESS, closeloop);

export const fetchError = (error: string) =>
  action(OfflinePaymentTypeGroupActionTypes.FETCH_ERROR, error);
